<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('任务标题')" prop="taskTitle">
                <a-input v-model="queryParam.taskTitle" :maxLength="32" :placeholder="$t('请输入')+$t('任务标题')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('姓名')" prop="userName">
                <a-input v-model="queryParam.userName" :maxLength="32" :placeholder="$t('请输入')+$t('姓名')" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('审核状态')" prop="auditStatus">
                <a-select v-model="queryParam.auditStatus" :placeholder="$t('请选择')" allow-clear>
                  <a-select-option v-for="(item, index) in customDict.AuditStatusEnum" :value="item.type" :key="item.type">
                    {{ $t(item.name) }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('查询') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" :disabled="multiple" @click="handleBatchPass(null)" v-hasPermi="['task:tasksubmit:edit']">
          {{ $t('审核通过') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleBatchRejectShow(null)" v-hasPermi="['task:tasksubmit:edit']">
          {{ $t('审核拒绝') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <detail-view
        ref="detailViewRef"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="submitTime" slot-scope="text, record">
          {{ parseTime(record.submitTime) }}
        </span>
        <span slot="auditTime" slot-scope="text, record">
          {{ parseTime(record.auditTime) }}
        </span>
        <span slot="auditStatus" slot-scope="text, record">
          <custom-dict-tag :options="customDict.AuditStatusEnum" :value="record.auditStatus"/>
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.detailViewRef.handleShow(record)" v-hasPermi="['task:tasksubmit:edit']">
            {{ $t('查看详情') }}
          </a>
          <template v-if="record.auditStatus === 1">
            <a-divider type="vertical" v-hasPermi="['task:tasksubmit:edit']" />
            <a @click="handleBatchPass(record)" v-hasPermi="['task:tasksubmit:edit']">
              {{ $t('审核通过') }}
            </a>
            <a-divider type="vertical" v-hasPermi="['task:tasksubmit:edit']" />
            <a @click="handleBatchRejectShow(record)" type="denger" v-hasPermi="['task:tasksubmit:edit']">
              {{ $t('审核拒绝') }}
            </a>
          </template>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>

    <reject-modal
      :visible="rejectModalVisible"
      :onReject="handleBatchReject"
      @cancel="rejectModalVisible = false"
    />
  </page-header-wrapper>
</template>

<script>
import { pageTaskSubmit, delTaskSubmit, batchPassTaskSubmit, batchRejectTaskSubmit } from '@/api/task/taskSubmit'
import CustomDictTag from '@/components/DictCustomTag'
import { mapGetters } from 'vuex'
import moment from 'moment'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import RejectModal from '@/components/RejectModal/index.vue'
import DetailView from '@/views/task/taskSubmit/modules/DetailView.vue'

export default {
  name: 'TaskSubmit',
  components: {
    DetailView,
    RejectModal,
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data() {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo: {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        id: undefined,
        taskId: undefined,
        userId: undefined,
        userName: undefined,
        submitTime: undefined,
        auditStatus: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: this.$t('任务标题'),
          dataIndex: 'taskTitle',
          ellipsis: true,
          align: 'center'
        },

        {
          title: this.$t('姓名'),

          dataIndex: 'userName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('提交时间'),
          dataIndex: 'submitTime',
          scopedSlots: { customRender: 'submitTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('审核状态'),
          dataIndex: 'auditStatus',
          scopedSlots: { customRender: 'auditStatus' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          width: '240px',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ],
      rejectModalVisible: false,
    }
  },
  filters: {},
  created() {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  methods: {
    moment,
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    /** 查询任务提交列表 */
    getList() {
      this.loading = true
      pageTaskSubmit(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParam = {
        id: undefined,
        taskId: undefined,
        userId: undefined,
        userName: undefined,
        submitTime: undefined,
        auditStatus: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField === 'createTime') {
          this.queryParam.sortField = 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = ''
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      var that = this
      const ids = row.id || this.ids
      if (row.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认删除所选中数据'),
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return delTaskSubmit(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('删除成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport() {
      var that = this
      this.$confirm({
        title: this.$t('是否确认导出'),
        content: this.$t('此操作将导出当前条件下所有数据而非选中数据'),
        onOk() {
          that.download('task/task/submit/export',
            that.queryParam
            , `taskSubmit_${new Date().getTime()}.xlsx`)
        },
        onCancel() {
        }
      })
    },
    handleBatchPass(row) {
      var that = this
      if (row?.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('确认通过选中数据'),
        onOk() {
          let data = []
          that.ids.map(id => data.push({ 'id': id }))
          return batchPassTaskSubmit(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('修改成功')
              that.$message.success(
                message,
                3
              )
            })
        },
        onCancel() {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    handleBatchRejectShow(row) {
      if (row?.id) {
        this.ids = []
        this.ids.push(row.id)
      }
      var that = this
      this.$confirm({
        title: this.$t('确认拒绝选中数据'),
        onOk() {
          that.rejectModalVisible = true
        },
        onCancel() {
          // 取消清空删除ids列表
          that.ids = []
          that.rejectModalVisible = false
        }
      })
    },
    handleBatchReject(reason) {
      var that = this
      const data = []
      that.ids.map(id => data.push(id))
      return batchRejectTaskSubmit({ ids: data, reason: reason })
        .then(() => {
          that.onSelectChange([], [])
          that.getList()
          const message = that.$t('拒绝成功')
          that.$message.success(
            message,
            3
          )
          this.rejectModalVisible = false
        }).catch(() => {
          this.rejectModalVisible = false
        })
    }
  }
}
</script>
